'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsageUser(email, name) {
  this.KD = null;
  this.Ds = null;
  this.KD = email;
  this.Ds = name;
}
export { $c_Lpresto_types$CredentialUsageUser as $c_Lpresto_types$CredentialUsageUser };
$p = $c_Lpresto_types$CredentialUsageUser.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsageUser;
/** @constructor */
function $h_Lpresto_types$CredentialUsageUser() {
}
export { $h_Lpresto_types$CredentialUsageUser as $h_Lpresto_types$CredentialUsageUser };
$h_Lpresto_types$CredentialUsageUser.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$CredentialUsageUser) && ((this.KD === x$0.KD) && (this.Ds === x$0.Ds))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "CredentialUsageUser";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KD;
  }
  if ((n === 1)) {
    return this.Ds;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$CredentialUsageUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jy)));
}
export { $isArrayOf_Lpresto_types$CredentialUsageUser as $isArrayOf_Lpresto_types$CredentialUsageUser };
var $d_Lpresto_types$CredentialUsageUser = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsageUser, "presto.types$CredentialUsageUser", ({
  jy: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CredentialUsageUser as $d_Lpresto_types$CredentialUsageUser };
//# sourceMappingURL=presto.types$-Credential-Usage-User.js.map
